module.exports = __webpack_public_path__ + "static/media/pic1.16bd5322.jpg";